import { type Enum } from '@webapp/infrastructure/types/Enum'

export const DeclinedTransactionReasons = {
  OTHER: 0,
  INSUFFICIENT_FUNDS: 1,
  UNSUPPORTED_CURRENCY: 2,
  FOREIGN_VENDOR: 3,
  LOCKED_CARD: 4,
  CANCELED_CARD: 5,
  VERIFICATION_FAILED: 6,
  SUSPECTED_FRAUD: 7,
  ACCOUNT_INVALID: 8,
  CARD_LOST_STOLEN: 9,
  CARD_NOT_ACTIVATED: 10,
  RESTRICTED_COUNTRY: 11,
  CURRENCY_NOT_ALLOWED: 12,
  NOT_SUPPORTED: 13,
  TRANSACTION_BLOCKED_AT_TERMINAL: 14,
  TRANSACTION_BLOCKED: 15,
} as const

export type DeclinedTransactionReasonEnum = Enum<
  typeof DeclinedTransactionReasons
>
